export default "__VITE_ASSET__pW2XwS1v__"